import React, { useEffect } from 'react';
import { BodyS, BodySBold, BodyMBold } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/views/bwodPlanDetailsStyle';
import { Box, Tooltip, makeStyles } from '@material-ui/core';
import Button from 'components/CustomButtons/Button';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Accordion from 'components/Accordion/Accordion';
import { dynamicTranslate, translate } from 'components/Translation';
import { color, status } from './constants';
import { extractplanDetails } from './helper';
import { useSelector } from 'react-redux';
import { getBwodLabels, getCommonLabels } from 'redux/modules/dynamicLabels/selectors';
import { getLanguage } from 'utils/language/language';
// @ts-ignore
const useStyles = makeStyles(styles);

interface IBWODPlanDetails {
	planStatus: string;
	allPlansDetails: any;
}

const BWODPlanDetails = ({ planStatus, allPlansDetails }: IBWODPlanDetails) => {
	const classes = useStyles({ buttonColor: color[planStatus]?.buttonColor });
	const [planDetails, setCardDetails] = React.useState<any>([]);
	const bwodLabels = useSelector(getBwodLabels);
	const commonLabels =  useSelector(getCommonLabels)

	useEffect(() => {
		const detailsArray = extractplanDetails(allPlansDetails, bwodLabels, commonLabels);
		setCardDetails(detailsArray);
	}, [allPlansDetails, getLanguage()]);

	//This method is used to render the plan details in single as well as accordion component
	const getDetails = (planInfo: any, accordion?: boolean, accordionClass?: string) => (
		<Box
			component="div"
			m={1}
			className={!accordion ? classes.planDetails : accordionClass ? classes[accordionClass] : ''}
		>
			{planInfo?.map((planInfo: any) => {
				return (
					<div className={classes.planInfoContent}>
						<BodyS changeFontSize={false} customClassName={classes.planInfolabel}>
							{planInfo.key}
						</BodyS>
						<BodySBold changeFontSize={false} customClassName={classes.planInfo}>
							{planInfo.value}
						</BodySBold>
					</div>
				);
			})}
		</Box>
	);

	const tootipTitle = (data: any) => {
		const keys = [bwodLabels.speedUpPrice, bwodLabels.validity];
		return data?.map((info: any, index: number) => {
			return (
				<li>
					<div className={classes.tooltipListItem}>
						<BodySBold customClassName={classes.tooltipKey}>{dynamicTranslate(keys[index])}</BodySBold>
						<BodySBold customClassName={classes.whiteText}>{info.value}</BodySBold>
					</div>
				</li>
			);
		});
	};
	// This method is used to render plan heading like plan name, info icon and tooltip, and status of the plan
	const renderPlanHeading = (serviceStatus?: string) => {
		//status will have some value when renderPlanHeading is being used by renderAccordion method to render more than 1 plan
		const statusTranslationKey = serviceStatus
			? `bwod.${serviceStatus.toLowerCase()}.status`
			: `bwod.${planStatus.toLowerCase()}.status`;
		return (
			<>
				{serviceStatus && <BodyMBold customClassName={classes.caption}> Add-on </BodyMBold>}
				<div className={serviceStatus ? classes.planWrapper : classes.singlePlanWrapper}>
					<div className={classes.planName}>
						<BodyMBold>{planDetails[0]?.planName}</BodyMBold>
						<Tooltip
							classes={{ tooltip: classes.toolTip }}
							title={<ul className={classes.tooltipInfo}>{tootipTitle(planDetails[0]?.tooltip)}</ul>}
						>
							<InfoOutlinedIcon fontSize="small" className={classes.infoIcon} />
						</Tooltip>
					</div>
					<>
						<Button
							className={!serviceStatus ? classes.statusButton : classes[serviceStatus.toLowerCase()]}
							disabled={true}
							color='primary-light'
						>
							{translate(statusTranslationKey)}
						</Button>
					</>
				</div>
			</>
		);
	};

	const renderAccordion = (
		<Accordion
			multiple
			collapses={planDetails.map((plan: any, index: number) => {
				const planStatus = plan.status;
				const accordionClass = planStatus === status.EXPIRED ? 'expiredBox' : 'accordionPlanDetails';
				return {
					title: renderPlanHeading(plan.status),
					content: getDetails(plan.body, true, accordionClass),
					backgroundColor: index == planDetails.length - 1 ? color[planStatus]?.accordion : '',
					expanded: plan.status === status.PENDING || plan.status === status.EXPIRED ? true : false,
				};
			})}
		/>
	);

	//If planDetails has more than one plan then we show an accordion
	return (
		<>
			{planDetails.length > 1 ? (
				renderAccordion
			) : (
				<>
					{renderPlanHeading()}
					{getDetails(planDetails[0]?.body)}
				</>
			)}
		</>
	);
};

export default BWODPlanDetails;
